module.exports = __webpack_public_path__ + "static/media/rescueIcon.f3271115.png";